import { FC } from 'react';

import * as S from 'view/modals/OnboardingWizard/styled';

interface DotStepperProps {
  totalSteps: number;
  currentStep: number;
}

const DotStepper: FC<DotStepperProps> = ({ totalSteps, currentStep }) => {
  return (
    <S.DotStepperContainer>
      {Array.from({ length: totalSteps }, (_, index) => {
        return <S.Dot key={`dot-${index}`} active={index === currentStep} />;
      })}
    </S.DotStepperContainer>
  );
};

export default DotStepper;
